import React, { useEffect, useState } from 'react';
import { fetchNotifications, approveAgency, deleteAgency, clearNotification, getAgencies, getUser } from '../services/firestoreService';
import NotificationsTable from '../components/Dashboard/NotificationsTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTrash } from '@fortawesome/free-solid-svg-icons';
import AgencyMetrics from '../components/Dashboard/AgencyMetrics';
import { useAuth } from '../context/AuthContext';
import AgencyTable from '../components/common/AgencyTable';

const Dashboard = () => {
  const [notifications, setNotifications] = useState([]);
  const [newAgencies, setNewAgencies] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const { user, logout } = useAuth();

  useEffect(() => {
    if (!user) return;

    const fetchUserRole = async () => {
      const roleData = await getUser(user.uid);
      if (roleData.role !== 'admin') {
        await logout();
      }
    };
    fetchUserRole();
  }, [user, logout]);

  useEffect(() => {
    const loadData = async () => {
      setNotifications(await fetchNotifications());
      setNewAgencies(await getAgencies());
    };
    loadData();
  }, []);

  const handleApprove = async (agencyId) => {
    await approveAgency(agencyId);
    setAgencies((prev) => prev.map((a) => (a.id === agencyId ? { ...a, isApproved: true } : a)));
  };

  const handleDelete = async (agencyId) => {
    if (window.confirm('Are you sure you want to delete this agency?')) {
      await deleteAgency(agencyId);
      setAgencies((prev) => prev.filter((a) => a.id !== agencyId));
    }
  };

  const handleClearNotification = async (notificationId) => {
    await clearNotification(notificationId);
    setNotifications((prev) => prev.filter((n) => n.id !== notificationId));
  };

  const filteredAgencies = newAgencies.filter((agency) =>
    notifications.some((n) => n.agencyId === agency.id)
  );

  const truncate = (text, max) => (text.length > max ? text.slice(0, max) + '...' : text);

  return (
    <div>
      <NotificationsTable notifications={notifications} onClear={handleClearNotification} />

      <div className="container mx-auto p-4">
        <AgencyMetrics agencies={newAgencies} />

        <h2 className="text-2xl font-bold text-secondary mb-4">Recent Agency Submissions</h2>

        <AgencyTable
            agencies={filteredAgencies}
            onApprove={handleApprove}
            onDelete={handleDelete}
            allowFeature={false}
          />

      </div>
    </div>
  );
};

export default Dashboard;
